import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { TableColumn } from '../models/table-column';
import { SessionQuery } from '../state-mangement/session/session.query';
import { SessionService } from '../state-mangement/session/session.service';
import { SideMenuQuery } from '../state-mangement/side-menu/side-menu.query';

@Injectable({
  providedIn: 'root',
})
/**
 * Checks if the user is logged in or not.
 */
export class AuthGuard {
  constructor(
    private sessionQuery: SessionQuery,
    private sessionService: SessionService,
    private sideMenuQuery: SideMenuQuery
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const url = state.url;
    return this.checkAuth(url);
  }

  private checkAuth(url: string) {
    return this.sessionQuery.successful$.pipe(
      take(1),
      map((loggedIn) => {
        if (!loggedIn) {
          this.sessionService.redirectToLogin(url);
          return false;
        }
        return true; // ← WICHTIG: immer etwas zurückgeben
      })
    );
  }

  // Tiefensuche nach URL und Rückgabe der Kette bis zum Treffer
  private findPathByUrl(
    nodes: TableColumn[],
    url: string,
    trail: TableColumn[] = []
  ): TableColumn[] | null {
    for (const n of nodes) {
      const isHit = !!n.url && url.includes(n.url);
      const newTrail = [...trail, n];

      if (isHit) return newTrail;

      if (n.children?.length) {
        const childPath = this.findPathByUrl(n.children, url, newTrail);
        if (childPath) return childPath;
      }
    }
    return null;
  }
}
